export default function collectAndSaveUserInfo($) {
  $(document).on('click', '.submit-button', function(e) {
    var email = $('.dropbox-email').val();
    document.cookie = `user_email=${email}; expires=""; path=/`;
    console.log(document.cookie);
  });

  $(document).on('click', '.wpfd_downloadlink', function(e) {
    var filename = $('.wpfd_downloadlink').attr('href').split('/').pop();
    var email = getCookieValue('user_email');
    var user_info = { filename, email };
    // console.log(user_info, document.cookie);
    $.post(
      ajaxurl,
      {
        // wp ajax action
        action: 'submit_user_info',
        // data
        user_info
      },
      function () {
        console.log('user info collected')
      }
    );

    $(document).ready(function() {
      var menu = $(".mediaMenuOption");
      console.log("MENU", menu);
    });
  });
}

function getCookieValue(a) {
  var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
  return b ? b.pop() : '';
}